import { render, staticRenderFns } from "./StockDifference.vue?vue&type=template&id=34e1ad1e&"
import script from "./StockDifference.vue?vue&type=script&lang=js&"
export * from "./StockDifference.vue?vue&type=script&lang=js&"
import style0 from "./StockDifference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports